/**
 * @generated SignedSource<<097c2c42a07ff2223cf935224cc0e17b>>
 * @relayHash dc02cba68b5b8d3e8f25932a9ba1fc85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba7a53e347f31a50b1c077c6ca77355786e1f50c5a176fba9eb0abdc12772654

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StakeholderCommsSearchField = "EMAIL_ID" | "%future added value";
export type StakeholderCommsStakeholderStatus = "ACTIVE" | "DELETED" | "INVITED" | "INVITED_PENDING_APPROVAL" | "NOT_INVITED" | "PENDING_IDENTITY_SETUP" | "QUARANTINED" | "%future added value";
export type StakeholderCommsStakeholderType = "EXTERNAL" | "GROUP" | "INTERNAL" | "TEAM" | "%future added value";
export type StakeholderCommsStakeholderConnectionFilter = {
  status?: ReadonlyArray<StakeholderCommsStakeholderStatus> | null | undefined;
  type?: ReadonlyArray<StakeholderCommsStakeholderType> | null | undefined;
};
export type StakeholderCommsStakeholderConnectionSearch = {
  searchField?: StakeholderCommsSearchField | null | undefined;
  searchValue?: string | null | undefined;
};
export type StakeholdersPageQuery$variables = {
  after?: string | null | undefined;
  filter?: StakeholderCommsStakeholderConnectionFilter | null | undefined;
  first: number;
  search?: StakeholderCommsStakeholderConnectionSearch | null | undefined;
};
export type StakeholdersPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StakeholderPageContent">;
};
export type StakeholdersPageQuery = {
  response: StakeholdersPageQuery$data;
  variables: StakeholdersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "StakeholderPageContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "StakeholderCommsStakeholderConnection",
        "kind": "LinkedField",
        "name": "stakeholderComms_listStakeholders",
        "plural": false,
        "selections": [
          {
            "concreteType": "StakeholderCommsStakeholderEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "StakeholderCommsStakeholder",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "aaid"
                  },
                  {
                    "concreteType": "StakeholderCommsNotificationPreference",
                    "kind": "LinkedField",
                    "name": "notificationPreference",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "emailId"
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  },
                  {
                    "concreteType": "StakeholderCommsGroups",
                    "kind": "LinkedField",
                    "name": "groups",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "avatar"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "error"
          },
          {
            "concreteType": "StakeholderCommsPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "filters": [
          "filter",
          "search"
        ],
        "handle": "connection",
        "key": "StakeholderTableLayout_stakeholderComms_listStakeholders",
        "kind": "LinkedHandle",
        "name": "stakeholderComms_listStakeholders"
      }
    ]
  },
  "params": {
    "id": "ba7a53e347f31a50b1c077c6ca77355786e1f50c5a176fba9eb0abdc12772654",
    "metadata": {},
    "name": "StakeholdersPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5d2fcc256d3d69fa8469975de7d26375";

export default node;
